import { useLanguage } from "@/contexts/LanguageContext";
import type { ModelInfo } from "@/lib/types/models";

/**
 * Derives a user-facing warning string when the selected model
 * is experiencing high demand (502/503/529 from upstream).
 *
 * Returns `undefined` when the model is operational.
 */
export function useModelWarning(
  modelId: string | undefined,
  models: ModelInfo[]
): string | undefined {
  const { t } = useLanguage();

  if (!modelId) return undefined;

  const model = models.find((m) => m.id === modelId);
  if (model?.status === "high_demand") {
    return t.generate.modelHighDemand;
  }

  return undefined;
}
